module.exports = __webpack_public_path__ + "static/media/GalleryMain1.8ee87882.jpg";